import { render, staticRenderFns } from "./PrinterDailyUsageTabsItems.vue?vue&type=template&id=2cf2620c&scoped=true"
import script from "./PrinterDailyUsageTabsItems.vue?vue&type=script&lang=js"
export * from "./PrinterDailyUsageTabsItems.vue?vue&type=script&lang=js"
import style0 from "./PrinterDailyUsageTabsItems.vue?vue&type=style&index=0&id=2cf2620c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2620c",
  null
  
)

export default component.exports